var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPages2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    viewBox: "0 0 32 32",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5,6V7.5H12A2.5,2.5,0,0,0,9.5,10V23.5H8A1.5,1.5,0,0,1,6.5,22V6A1.5,1.5,0,0,1,8,4.5H20A1.5,1.5,0,0,1,21.5,6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24,8.5H12A1.5,1.5,0,0,0,10.5,10V26A1.5,1.5,0,0,0,12,27.5H24A1.5,1.5,0,0,0,25.5,26V10A1.5,1.5,0,0,0,24,8.5Zm-6,13H14a.5.5,0,0,1,0-1h4a.5.5,0,0,1,0,1Zm4-4H14a.5.5,0,0,1,0-1h8a.5.5,0,0,1,0,1Zm0-4H14a.5.5,0,0,1,0-1h8a.5.5,0,0,1,0,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPages2);
export default __webpack_public_path__ + "static/media/pages2.352a2af5.svg";
export { ForwardRef as ReactComponent };